export enum RedoType {
	NO_REDO = "NO_REDO",
	LYSIS_REDO = "LYSIS_REDO",
    EXTRACTION_REDO = "EXTRACTION_REDO",
    ALIQUOTATION_REDO = "ALIQUOTATION_REDO",
    DNA_REDO = "DNA_REDO",
    MERGE_REDO = "MERGE_REDO"
}